export const EXCLUSIVE_DOMAINS = [
  'herospark.co',
  'heroi.dev',
  'localhost',
  'herospark.com',
]
